import { toast } from "react-toastify";
import Swal from "sweetalert2";
// import "./SweetAlert.css";

const deleteModel = async (handleDelete, id, extraMesg) => {
    try {
        await Swal.fire({
            title: "Are you sure?",
            text: extraMesg || "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        }).then((result) => {
            if (result.isConfirmed) {
                handleDelete(id);
            }
        });
    } catch (error) {
        toast.error(
            error?.response?.data?.message ||
            error?.message ||
            "Something went wrong!"
        );
        Swal.fire("Error!", "Something went wrong", "error");
    }
}

export default deleteModel;